export const nl = {
  AndereRedenNamelijk: "Andere reden, namelijk...",
  Aanhef: "Aanhef",
  DeHeer: "De heer",
  Mevrouw: "Mevrouw",
  Voorletters: "Voorletters",
  Achternaam: "Achternaam",
  Geboortenaam: "Geboortenaam",
  KenmerkCAK: "Kenmerk CAK",
  KenmerkCAKInfoTxt: "Uw CAK ID-nummer, kenmerk of referentie van de brief, uw zaaknummer.",
  Straat: "Straat",
  Huisnummer: "Huisnummer",
  Toevoeging: "Toevoeging",
  Postcode: "Postcode",
  Woonplaats: "Woonplaats",
  Land: "Land",
  Telefoonnummer: "Telefoonnummer",
  EmailAdres: "E-mailadres",
  EmailAdresInfoTxt: "Wij gebruiken dit e-mailadres als wij contact met u willen opnemen over uw bericht.",
  Onderwerp: "Onderwerp",
  OmschrijvingKlacht: "Omschrijving klacht",
  HeeftUNogAanvullendeOpmerkingen: "Heeft u nog aanvullende opmerkingen?",
  bijlage: "bijlage",
  bijlagen: "bijlagen",
  Bijlagen: "Bijlage(n)",
  Bijlage: "Bijlage",
  BijlageToevoegen: "Bijlage toevoegen",
  MeldingNoteerNummerVoorVerzending:
    "Noteer het nummer dat verschijnt na het versturen. Heeft u nog vragen? Geef dan dit nummer door. Zo kunnen wij u beter helpen.",
  MeldingNoteerNummerNaVerzending:
    "Noteer bovenstaand nummer. Heeft u nog vragen? Geef dan dit nummer door. Zo kunnen wij u beter helpen.",
  KlachtenFormulierZvw: "Klachtenformulier Zvw",
  OplossingKlacht: "Wat zou volgens u de oplossing van uw klacht moeten zijn?",
  BijlageInfoTextMax1Attachment: "Maximaal 1 bijlage, maximaal 5 MB per bijlage.",
  BijlageInfoTextMax5Attachments: "Maximaal 5 bijlagen, maximaal 5 MB per bijlage.",
  NaarOnzeHomepage: "Naar onze homepage",
  IsRequiredValidationFactoryValidationText: "U heeft het invulveld '{{label}}' niet ingevuld.",
  HasMaxLengthValidationFactoryValidationText:
    "U heeft het invulveld '{{label}}' niet juist ingevuld, u mag maximaal {{maxLength}} karakters invullen.",
  IsPostcodeValidationFactoryValidationText:
    "U heeft het invulveld '{{label}}' niet juist ingevuld, voorbeeld: 1234 AB (vervangen door uw eigen postcode).",
  FileMaxSizeValidationText:
    "U heeft in het invulveld '{{label}}' meer dan de maximaal toegestane bestandsgrootte geüpload, bijlagen mogen maximaal 5MB zijn.",
  FileMaxSizeValidationTextAlternative:
    "'{{label}}' is groter dan de maximaal toegestane bestandsgrootte, bijlagen mogen maximaal 5MB zijn.",
  FileMaxNumberOfAttachmentsValidationText:
    "U heeft in het invulveld '{{label}}' meer dan het toegestane aantal bijlagen geüpload, u mag maximaal {{maxFiles}} {{bijlagen}} uploaden.",
  GemoedsbezwaardenFormulierStapMijnVerzoek: "Mijn verzoek",
  Inleiding: "Inleiding",
  MijnGegevens: "Mijn gegevens",
  ErKunnenMaximaalAantalTekensIngevoerdWorden: "Er kunnen maximaal {{aantal}} tekens ingevoerd worden",
  StopzettenBroninhoudingFormulierStapMijnVerzoek: "Mijn verzoek",
  DeUitkeringStoptOfDeWerknemerGaatUitDienst: "De uitkering stopt of de werknemer gaat uit dienst",
  DeUitkeringOfHetSalarisIsTeLaagOmPremieInTeHouden:
    "De uitkering of het salaris is te laag om zorgpremie in te houden",
  HetBedrijfIsFailliet: "Het bedrijf is failliet",
  HetBedrijfIsOpgeheven: "Het bedrijf is opgeheven"
};
